<template>
  <InnerView>
    <template #header>
      <div class="space-y-2">
        <h1
          class="flex items-center font-bold text-primary-contrast pl-1 tracking-wide transition-all text-3xl"
        >
          {{ $t('favorites.title') }}
        </h1>
        <favorites-bar-view :language="focusDefaultLanguage || 'default'" />
      </div>
    </template>
    <favorites-list-view @select-item="showEntity" />
  </InnerView>
</template>

<script setup lang="ts">
import InnerView from '@commons/components/Layout/InnerView.vue'
import { useKnowledgeStore } from '@getmayday/vue-modules'

const knowledgeStore = useKnowledgeStore()

const { showEntity } = useEntities()
const { focusDefaultLanguage } = storeToRefs(knowledgeStore)
</script>
